export default __webpack_public_path__ + "static/media/nura.6d0b4457.jpeg";